import Const from 'constants';
import {UsedTeams as ClassicMLBUsedTeams} from './mlb/classic';
import {UsedTeams as ClassicLOLUsedTeams} from './lol/classic';
import {UsedTeams as ClassicNHLUsedTeams} from './nhl/classic';

const componentMap = {
    [Const.LEAGUE_MLB]: ClassicMLBUsedTeams,
    [Const.LEAGUE_LOL]: ClassicLOLUsedTeams,
    [Const.LEAGUE_NHL]: ClassicNHLUsedTeams,
};

const Factory = {
    getComponent(sportConfig) {
        const sport = sportConfig.getSport().toLowerCase();

        try {
            return componentMap[sport];
        } catch (e) {
            return null;
        }
    },
};

export {Factory};
